export default __webpack_public_path__ + "static/media/t6.b54cf70a.jpeg";